import { listCatalogBranches } from "@/commands/catalog/list-catalog-branches";
import { listCatalogModels } from "@/commands/catalog/list-catalog-models";
import { listCatalogRepos } from "@/commands/catalog/list-catalog-repos";
import { listCatalogSkills } from "@/commands/catalog/list-catalog-skills";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

/**
 * What `hepha catalog <topic>` can list. A table rather than a chain of
 * comparisons: adding a topic is one line, and the set of topics is readable
 * without following four branches.
 */
export const catalogTopics: Record<
  string,
  (parsed: ParsedArgs, asJson: boolean) => Promise<void>
> = {
  branches: listCatalogBranches,
  models: listCatalogModels,
  repos: listCatalogRepos,
  skills: listCatalogSkills,
};
